import { store } from '../../../configuration/setup/store';
import { trace } from '../../../configuration/setup/trace';
import { updateWidgetId } from '../widgetSlice';

export const SET_WIDGET_ID_EVENT = 'EVENT_SET_WIDGET_ID';

export const setWidgetIdHandler = (data: string) => {
    trace.debug('Set widget id:', data);
    store.dispatch(updateWidgetId(data));
};
